<template>
  <div class="messages-card-list">
    <div class="message-card-con" v-for="(message, idx) in messages" :key="idx">
      <div v-for="(company, idx) in message.company" :key="idx">
        <RfpsMessageCard :message="message" :company="company" :active="active" class="message-card clickable" :class="(active.id == message.id && active.company.company_id == company.company_id)? 'active':''" @click.native="handleOnChangeActiveMessage(message, company)"/>
      </div>
    </div>
  </div>
</template>

<script>
import RfpsMessageCard from './RfpsMessageCard'

export default {
  props: {
    messages: {
      type: Array,
      default: () => []
    },
    active: {
      type: Object,
      default: () => {}
    }
  },

  components: {
    RfpsMessageCard
  },

  methods: {
    handleOnChangeActiveMessage (message, company) {
      this.$emit('change', message, company)
    }
  }
}
</script>

<style lang="scss" scoped>
.messages-card-list {
  height: calc(100% - 20px);
  overflow-y: scroll;
  overflow-x: hidden;
  overflow: auto;
  .message-card-con {
    .message-card {
      margin: 15px 5px;
      border: 0px;
      &.active {
        background: #f2f2f2;
      }
    }
  }
}
</style>
